import React from 'react';
import { connect } from 'react-redux';
import PieChart from '../../../Charts/PieChart';
import * as actions from '../../../../store/actions/index';

const PieSaldoAcreedoresPorEmpresa = (props) => {

  const handlePorcionClick = (config) => {
    props.onPorcionClick(config);
  };

  return (
    <PieChart
      title={props.title}
      subTitle={props.subtitle}
      series={props.saldosPorEmpresa.map((saldo) => saldo.total)}
      labels={props.saldosPorEmpresa.map((saldo) => saldo.nombreEmpresa)}
      ids={props.saldosPorEmpresa.map((saldo) => saldo.id)}
      imgSinDatos={props.totalSaldos <= 0}
      loading={!props.estaOculto && props.loading && props.ejecucionDePagina}
      chartType={'pie'}
      height={props.height}
      disabled={props.estaOculto}
      width={'100%'}
      onPorcionClick={handlePorcionClick}
      onChangeViewClick={props.onChangeViewClick}
    />
  );
};
const mapStateToProps = (state) => {
  return {
    saldosPorEmpresa: state.multiempresa.saldoAcreedoresPorEmpresa.saldos,
    loading: state.multiempresa.saldoAcreedoresPorEmpresa.loading,
    estaCargado: state.multiempresa.saldoAcreedoresPorEmpresa.estaCargado,
    estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.saldoAcreedoresMultiempresa
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: () => dispatch(actions.loadSaldoAcreedoresPorEmpresa())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PieSaldoAcreedoresPorEmpresa);
